export const StorageConfig = {
    directory: {
        countrySpecificities: 'country-specificities',
        seo: 'seo',
        contentAsset: 'content-assets',
    },
    filename: {
        seo: {
            layout: 'layout.json',
            home: 'home.json',
            productDetail: 'pdp.json',
        },
        featuresFlags: 'features-flags.json',
        headerSlots: 'header-slots.json',
        contentAsset: 'content-assets-transformers.json',
    },
    prefix: {
        default: 'default',
    },
};
